import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Modal, Row } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { utils, writeFileXLSX } from "xlsx";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { clearGetPermission, getPermission } from "../../../redux/handlers/permission/getPermission.handler";
import { clearDeletePermission, deletePermission } from "../../../redux/handlers/permission/deletePermission.handler";
import { clearUpdatePermissionStatus, updatePermissionStatus } from "../../../redux/handlers/permission/updatePermissionStatus.handler";
var normalizePermission = function(permission) {
    return {
        sys_role_id: permission === null || permission === void 0 ? void 0 : permission.sys_role_id,
        sys_role_name: (permission === null || permission === void 0 ? void 0 : permission.sys_role_name) || "-",
        user_count: Number((permission === null || permission === void 0 ? void 0 : permission.user_count) || 0),
        sys_role_is_active: Number(permission === null || permission === void 0 ? void 0 : permission.sys_role_is_active) === 1 ? 1 : 0
    };
};
var getPermissionPayload = function(response, limit) {
    var payload = response;
    for(var index = 0; index < 3; index += 1){
        if (Array.isArray(payload)) {
            return {
                rows: payload,
                totalAmount: payload.length,
                totalPage: payload.length > 0 ? Math.ceil(payload.length / limit) : 0
            };
        }
        if (!payload || typeof payload !== "object") break;
        var rows = [
            payload.rows,
            payload.datalist,
            payload.items,
            payload.list,
            payload.data
        ].find(Array.isArray);
        if (rows) {
            var pagination = payload.pagination || payload.meta || {};
            var _pagination_total, _ref, _ref1, _ref2;
            var totalAmount = Number((_ref2 = (_ref1 = (_ref = (_pagination_total = pagination.total) !== null && _pagination_total !== void 0 ? _pagination_total : pagination.totalAmount) !== null && _ref !== void 0 ? _ref : pagination.total_amount) !== null && _ref1 !== void 0 ? _ref1 : payload.total) !== null && _ref2 !== void 0 ? _ref2 : rows.length);
            var _pagination_totalPage, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8;
            var totalPage = Number((_ref8 = (_ref7 = (_ref6 = (_ref5 = (_ref4 = (_ref3 = (_pagination_totalPage = pagination.totalPage) !== null && _pagination_totalPage !== void 0 ? _pagination_totalPage : pagination.totalPages) !== null && _ref3 !== void 0 ? _ref3 : pagination.total_page) !== null && _ref4 !== void 0 ? _ref4 : pagination.lastPage) !== null && _ref5 !== void 0 ? _ref5 : pagination.last_page) !== null && _ref6 !== void 0 ? _ref6 : payload.totalPage) !== null && _ref7 !== void 0 ? _ref7 : payload.total_page) !== null && _ref8 !== void 0 ? _ref8 : totalAmount > 0 ? Math.ceil(totalAmount / limit) : 0);
            return {
                rows: rows,
                totalAmount: Number.isFinite(totalAmount) ? totalAmount : rows.length,
                totalPage: Number.isFinite(totalPage) ? totalPage : 0
            };
        }
        if (payload.data === undefined) break;
        payload = payload.data;
    }
    return {
        rows: [],
        totalAmount: 0,
        totalPage: 0
    };
};
var getComparableValue = function(item, field) {
    var value = item === null || item === void 0 ? void 0 : item[field];
    return typeof value === "string" ? value.toLocaleLowerCase("th-TH") : value;
};
export function Permission() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var modalContextRef = useRef({
        modalObj: modalObj,
        setModalObj: setModalObj
    });
    modalContextRef.current = {
        modalObj: modalObj,
        setModalObj: setModalObj
    };
    var getPermissionReducer = useAppSelector(function(state) {
        return state.getPermissionReducer;
    });
    var deletePermissionReducer = useAppSelector(function(state) {
        return state.deletePermissionReducer;
    });
    var updatePermissionStatusReducer = useAppSelector(function(state) {
        return state.updatePermissionStatusReducer;
    });
    var _useState = _sliced_to_array(useState([]), 2), permissionData = _useState[0], setPermissionData = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), selectedPermission = _useState2[0], setSelectedPermission = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), updatingPermissionStatus = _useState3[0], setUpdatingPermissionStatus = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), pageId = _useState4[0], setPageId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(10), 2), pageSize = _useState5[0], setPageSize = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), totalPage = _useState6[0], setTotalPage = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), totalAmount = _useState7[0], setTotalAmount = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), reloadKey = _useState8[0], setReloadKey = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        sortField: "sys_role_id",
        sortValue: "asc"
    }), 2), sortModel = _useState9[0], setSortModel = _useState9[1];
    useEffect(function() {
        dispatch(getPermission({
            search: filterText,
            page: pageId,
            limit: pageSize
        }, modalContextRef.current));
    }, [
        dispatch,
        filterText,
        pageId,
        pageSize,
        reloadKey
    ]);
    useEffect(function() {
        return function() {
            dispatch(clearGetPermission());
            dispatch(clearDeletePermission());
            dispatch(clearUpdatePermissionStatus());
        };
    }, [
        dispatch
    ]);
    useEffect(function() {
        if (getPermissionReducer.data && !getPermissionReducer.isError) {
            var result = getPermissionPayload(getPermissionReducer.data, pageSize);
            setPermissionData(result.rows.map(normalizePermission));
            setTotalPage(result.totalPage);
            setTotalAmount(result.totalAmount);
        } else if (getPermissionReducer.isError) {
            setPermissionData([]);
            setTotalPage(0);
            setTotalAmount(0);
        }
    }, [
        getPermissionReducer,
        pageSize
    ]);
    var sortedItems = useMemo(function() {
        var sortField = sortModel.sortField, sortValue = sortModel.sortValue;
        var direction = sortValue === "desc" ? -1 : 1;
        return _to_consumable_array(permissionData).sort(function(firstItem, secondItem) {
            var firstValue = getComparableValue(firstItem, sortField);
            var secondValue = getComparableValue(secondItem, sortField);
            if (firstValue === secondValue) return 0;
            if (firstValue === null || firstValue === undefined) return 1;
            if (secondValue === null || secondValue === undefined) return -1;
            return firstValue > secondValue ? direction : -direction;
        });
    }, [
        permissionData,
        sortModel
    ]);
    var tableItems = useMemo(function() {
        return sortedItems.map(function(item, index) {
            return _object_spread_props(_object_spread({}, item), {
                permission_no: pageSize * (pageId - 1) + index + 1
            });
        });
    }, [
        pageId,
        pageSize,
        sortedItems
    ]);
    useEffect(function() {
        if (totalPage > 0 && pageId > totalPage) {
            setPageId(totalPage);
        }
    }, [
        pageId,
        totalPage
    ]);
    useEffect(function() {
        if (deletePermissionReducer.data !== null && !deletePermissionReducer.isError) {
            setSelectedPermission(null);
            dispatch(clearDeletePermission());
            if (permissionData.length === 1 && pageId > 1) {
                setPageId(function(currentPage) {
                    return currentPage - 1;
                });
            } else {
                setReloadKey(function(currentKey) {
                    return currentKey + 1;
                });
            }
        }
    }, [
        deletePermissionReducer,
        dispatch,
        pageId,
        permissionData.length
    ]);
    useEffect(function() {
        if (updatePermissionStatusReducer.isSuccess) {
            setUpdatingPermissionStatus(null);
            dispatch(clearUpdatePermissionStatus());
            setReloadKey(function(currentKey) {
                return currentKey + 1;
            });
        } else if (updatePermissionStatusReducer.isError && updatingPermissionStatus) {
            setPermissionData(function(currentData) {
                return currentData.map(function(permission) {
                    return permission.sys_role_id === updatingPermissionStatus.sys_role_id ? _object_spread_props(_object_spread({}, permission), {
                        sys_role_is_active: updatingPermissionStatus.previousStatus
                    }) : permission;
                });
            });
            setUpdatingPermissionStatus(null);
            dispatch(clearUpdatePermissionStatus());
        }
    }, [
        dispatch,
        updatePermissionStatusReducer,
        updatingPermissionStatus
    ]);
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
        setPageId(1);
    };
    var handleSort = function(column, sortDirection) {
        if (!(column === null || column === void 0 ? void 0 : column.sortField)) return;
        setSortModel({
            sortField: column.sortField,
            sortValue: sortDirection
        });
        setPageId(1);
    };
    var handleDeletePermission = function() {
        if (!selectedPermission || deletePermissionReducer.isFetching) return;
        dispatch(deletePermission({
            sys_role_id: selectedPermission.sys_role_id
        }, modalContextRef.current));
    };
    var handleUpdatePermissionStatus = function(permission) {
        if (updatePermissionStatusReducer.isFetching) return;
        var nextStatus = permission.sys_role_is_active === 1 ? 0 : 1;
        setUpdatingPermissionStatus({
            sys_role_id: permission.sys_role_id,
            previousStatus: permission.sys_role_is_active
        });
        setPermissionData(function(currentData) {
            return currentData.map(function(item) {
                return item.sys_role_id === permission.sys_role_id ? _object_spread_props(_object_spread({}, item), {
                    sys_role_is_active: nextStatus
                }) : item;
            });
        });
        dispatch(updatePermissionStatus({
            sys_role_id: permission.sys_role_id,
            sys_role_is_active: nextStatus
        }, modalContextRef.current));
    };
    var handleExport = function() {
        var exportData = sortedItems.map(function(item, index) {
            return {
                ลำดับ: index + 1,
                ชื่อสิทธิ์การใช้งาน: item.sys_role_name,
                จำนวนคนที่ใช้งานสิทธิ์: item.user_count,
                สถานะ: item.sys_role_is_active === 1 ? "เปิดใช้งาน" : "ปิดใช้งาน"
            };
        });
        var worksheet = utils.json_to_sheet(exportData);
        var workbook = utils.book_new();
        var timestamp = new Date().toISOString().replace(/[-:T.Z]/g, "").slice(0, 14);
        utils.book_append_sheet(workbook, worksheet, "Permission");
        writeFileXLSX(workbook, "permission_".concat(timestamp, ".xlsx"));
    };
    var columns = [
        {
            name: "ลำดับ",
            selector: function(row) {
                return row.permission_no;
            },
            sortField: "sys_role_id",
            sortable: true,
            center: "true",
            width: "100px"
        },
        {
            name: "ชื่อสิทธิ์การใช้งาน",
            selector: function(row) {
                return row.sys_role_name;
            },
            sortField: "sys_role_name",
            sortable: true,
            minWidth: "260px"
        },
        {
            name: "จำนวนคนที่ใช้งานสิทธิ์",
            selector: function(row) {
                return row.user_count;
            },
            sortField: "user_count",
            sortable: true,
            center: "true",
            minWidth: "210px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.sys_role_is_active;
            },
            sortField: "sys_role_is_active",
            sortable: true,
            center: "true",
            minWidth: "160px",
            cell: function(row) {
                var isActive = row.sys_role_is_active === 1;
                var isUpdating = updatePermissionStatusReducer.isFetching && (updatingPermissionStatus === null || updatingPermissionStatus === void 0 ? void 0 : updatingPermissionStatus.sys_role_id) === row.sys_role_id;
                return /*#__PURE__*/ _jsx("div", {
                    className: "d-flex align-items-center justify-content-center",
                    children: /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "px-2 py-1 fw-semibold",
                        onClick: function() {
                            return handleUpdatePermissionStatus(row);
                        },
                        disabled: updatePermissionStatusReducer.isFetching,
                        "aria-label": "เปลี่ยนสถานะ ".concat(row.sys_role_name),
                        style: {
                            border: 0,
                            borderRadius: 20,
                            color: isActive ? "#2E7D32" : "#B00412",
                            backgroundColor: isActive ? "#EAF7E4" : "#FDEBEC",
                            whiteSpace: "nowrap",
                            cursor: updatePermissionStatusReducer.isFetching ? "not-allowed" : "pointer"
                        },
                        children: isUpdating ? "กำลังอัปเดต..." : isActive ? "เปิดใช้งาน" : "ปิดใช้งาน"
                    })
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.sys_role_id;
            },
            center: "true",
            width: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center justify-content-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/setting/permission/edit/".concat(row.sys_role_id),
                            title: "แก้ไข ".concat(row.sys_role_name),
                            "aria-label": "แก้ไข ".concat(row.sys_role_name),
                            className: "d-inline-flex text-decoration-none",
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "d-inline-flex p-0 border-0 bg-transparent",
                            title: "ลบ ".concat(row.sys_role_name),
                            "aria-label": "ลบ ".concat(row.sys_role_name),
                            onClick: function() {
                                return setSelectedPermission(row);
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "pagezoom",
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx(Link, {
                                to: "/setting/master",
                                className: "tc-7 text-decoration-none",
                                children: "ตั้งค่า"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active tc-1",
                            "aria-current": "page",
                            children: "กำหนดสิทธิ์ผู้ใช้งาน"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "fs-24 mb-3",
                children: "กำหนดสิทธิ์ผู้ใช้งาน"
            }),
            /*#__PURE__*/ _jsx(Row, {
                className: "mb-3 g-2",
                children: /*#__PURE__*/ _jsx(Col, {
                    xs: 12,
                    sm: "auto",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        variant: "",
                        className: "btn-st-7 px-4 w-100",
                        "aria-pressed": "true",
                        children: "สิทธิ์จัดการเมนู"
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Card, {
                className: "card-st-2",
                children: [
                    /*#__PURE__*/ _jsx(CardBody, {
                        children: /*#__PURE__*/ _jsxs(Row, {
                            className: "align-items-center justify-content-between g-3",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: "auto",
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        variant: "",
                                        className: "btn-export-st-1 w-100",
                                        onClick: handleExport,
                                        disabled: tableItems.length === 0,
                                        children: "ส่งออกรายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: true,
                                    children: /*#__PURE__*/ _jsxs(Row, {
                                        className: "justify-content-end g-2",
                                        children: [
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                lg: 7,
                                                xl: 6,
                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                    controlId: "permission-search",
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "search",
                                                        className: "form-st-4 w-100",
                                                        style: {
                                                            minWidth: 0
                                                        },
                                                        placeholder: "ค้นหาข้อมูลตามสิทธิ์",
                                                        value: filterText,
                                                        onChange: function(event) {
                                                            setFilterText(event.target.value);
                                                            setPageId(1);
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Col, {
                                                xs: 12,
                                                lg: "auto",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    as: Link,
                                                    to: "/setting/permission/create",
                                                    type: "button",
                                                    variant: "",
                                                    className: "btn-st-7 px-4 w-100",
                                                    children: "เพิ่มสิทธิ์"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            loading: getPermissionReducer.isFetching,
                            item: tableItems,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: setPageId,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: Boolean(selectedPermission),
                onHide: function() {
                    if (!deletePermissionReducer.isFetching) setSelectedPermission(null);
                },
                size: "sm",
                centered: true,
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        className: "modal-header-danger py-2",
                        children: /*#__PURE__*/ _jsx(Modal.Title, {
                            className: "fs-18",
                            children: "ยืนยันลบสิทธิ์"
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        className: "px-4 py-3",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fs-18 tc-5 mb-2",
                                children: "คุณต้องการลบข้อมูลนี้หรือไม่"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-center fw-semibold text-break",
                                children: selectedPermission === null || selectedPermission === void 0 ? void 0 : selectedPermission.sys_role_name
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Footer, {
                        className: "justify-content-center border-0 pt-0 pb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 px-3",
                                onClick: function() {
                                    return setSelectedPermission(null);
                                },
                                disabled: deletePermissionReducer.isFetching,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-dg px-3",
                                onClick: handleDeletePermission,
                                disabled: deletePermissionReducer.isFetching,
                                children: deletePermissionReducer.isFetching ? "กำลังลบ..." : "ยืนยัน"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default Permission;
